import { UserOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client/react';
import { List, Popover, Spin, Tag, Typography, theme } from 'antd';
import type React from 'react';
import { useState } from 'react';
import { Link } from 'react-router';
import { ASSIGNED_USERS_QUERY } from './AssignedUsersPopover.gql';
export const AssignedUsersPopover: React.FC<{ doctorId: string; count: number }> = ({ doctorId, count }) => {
  const { token } = theme.useToken();
  const [open, setOpen] = useState(false);

  const { data, loading } = useQuery(ASSIGNED_USERS_QUERY, {
    variables: { doctorId, page: 1, pageSize: 100 },
    skip: !open,
  });

  const users = data?.users?.items ?? [];

  if (count === 0) return <Typography.Text type="secondary">–</Typography.Text>;

  return (
    <div onClick={e => e.stopPropagation()}>
      <Popover
        title={
          <>
            <UserOutlined style={{ marginRight: token.marginXXS }} /> Zugeordnete Benutzer
            <br />
            <Link to={`/admin/benutzer?doctorId=${encodeURIComponent(doctorId)}`} style={{ fontSize: token.fontSizeSM }}>
              In Benutzerverwaltung anzeigen
            </Link>
          </>
        }
        trigger="click"
        open={open}
        onOpenChange={setOpen}
        content={
          loading ? (
            <Spin size="small" />
          ) : (
            <List
              size="small"
              style={{ maxHeight: 300, overflowY: 'auto' }}
              dataSource={users}
              renderItem={user => (
                <List.Item style={{ padding: '4px 0' }}>
                  <Typography.Text>
                    {user.firstName} {user.lastName}
                  </Typography.Text>
                  <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
                    {user.username}
                  </Typography.Text>
                  {user.disabled && (
                    <Tag color="default" style={{ marginLeft: 8 }}>
                      inaktiv
                    </Tag>
                  )}
                </List.Item>
              )}
            />
          )
        }
      >
        <a>
          {count} <UserOutlined />
        </a>
      </Popover>
    </div>
  );
};
